import React, { FC } from 'react';

import moment from 'moment';

import { maskedPhone } from 'utils/masked-phone';

type RowTemplateProps = {
  data: any;
  claims: boolean;
};

const RowTemplate: FC<RowTemplateProps> = (props) => {
  let nomenclatureName = props.data.nomenclatureName.replace(' ', '<br>');
  nomenclatureName = `${nomenclatureName}(${props.data.density})`;

  return (
    <tbody
      className={'employee dx-row row-hover'}
      style={{ borderBottom: '1px solid rgb(199 194 194)', backgroundColor: props.data.requestStatus.color }}
    >
      <tr className="notes-row">
        <td rowSpan={2} style={{ verticalAlign: 'middle', position: 'relative' }}>
          {props.data.requestStatus.description}
        </td>
        <td rowSpan={2} style={{ fontSize: 16, verticalAlign: 'middle', textAlign: 'center' }}>
          {props.data.id}
        </td>
        <td rowSpan={2} style={{ fontSize: 12, verticalAlign: 'middle', textAlign: 'center' }}>
          <div>{moment(props.data.date).format('DD.MM.YYYY')}</div>
          <div style={{ fontSize: 18 }}>{moment(props.data.time).format('HH:mm')}</div>
        </td>
        <td colSpan={2}>
          <div style={{ fontWeight: 'bold' }}> {props.data.contractor}</div>
        </td>
        <td rowSpan={2} style={{ fontSize: 16, textAlign: 'center', verticalAlign: 'middle' }}>
          {maskedPhone(props.data.phone)}
        </td>
        <td rowSpan={2} style={{ fontSize: 16, textAlign: 'center', verticalAlign: 'middle' }}>
          <div dangerouslySetInnerHTML={{ __html: nomenclatureName }} />
        </td>
        <td rowSpan={2} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
          {props.data.contractorPump}
        </td>
        <td rowSpan={2} style={{ verticalAlign: 'middle', background: props.data.comment ? '#FF2F2F' : 'none' }}>
          <div style={{ whiteSpace: 'normal' }}>{props.data.comment}</div>
        </td>
        <td rowSpan={2} style={{ verticalAlign: 'middle', background: props.data.design ? '#FF2F2F' : 'none' }}>
          <div style={{ whiteSpace: 'normal' }}>{props.data.design}</div>
        </td>
        <td
          rowSpan={2}
          style={{
            textAlign: 'right',
            fontSize: 20,
            verticalAlign: 'middle',
            borderLeft: '1px dashed rgb(199 194 194)',
          }}
        >
          <div>{props.data.quantity}</div>
        </td>
        <td rowSpan={2} style={{ textAlign: 'right', fontSize: 20, verticalAlign: 'middle' }}>
          <div>{props.data.shipped}</div>
        </td>
        <td
          rowSpan={2}
          style={{
            textAlign: 'right',
            fontSize: 20,
            verticalAlign: 'middle',
            borderRight: '1px dashed rgb(199 194 194)',
          }}
        >
          <div>{(props.data.quantity - props.data.shipped).toFixed(2)}</div>
        </td>
      </tr>
      <tr className="main-row">
        <td style={{ fontSize: 16 }}>{props.data.object}</td>
        <td style={{ fontSize: 16 }}>{props.data.address}</td>
      </tr>
    </tbody>
  );
};

export default RowTemplate;
